import { render } from "./ProtocolTextDescription.vue?vue&type=template&id=cb8699ea"
import script from "./ProtocolTextDescription.vue?vue&type=script&lang=js"
export * from "./ProtocolTextDescription.vue?vue&type=script&lang=js"

import "./ProtocolTextDescription.vue?vue&type=style&index=0&id=cb8699ea&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__